import { render, staticRenderFns } from "./PaperItemChoose.vue?vue&type=template&id=2714d72a&scoped=true&"
import script from "./PaperItemChoose.vue?vue&type=script&lang=js&"
export * from "./PaperItemChoose.vue?vue&type=script&lang=js&"
import style0 from "./PaperItemChoose.vue?vue&type=style&index=0&id=2714d72a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2714d72a",
  null
  
)

export default component.exports